import imported_asset_index_tsx_0 from '../../../assets/Icons/close.svg';
import imported_asset_index_tsx_1 from '../../../assets/Icons/menu.svg';
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { alca } from "../../../alca/alca";
import logo from '../../../assets/Icons/logo.svg';
import yemeksepetiLogo from '../../../assets/Icons/yemeksepeti-logo-vendor.png';
import { isLoanFlow } from '../../../util/routeUtils';
import Image from "../../modules/image";
import './header.scss';

const Header = () => {
    const location = useLocation();
    const isLoan = isLoanFlow(location.pathname);
    const currentLogo = isLoan ? yemeksepetiLogo : logo;
    const [menu, setMenu] = useState(false);

    useEffect(() => {
        alca.scroll.lock(menu);
    }, [menu]);

    const toggleMenu = (event: React.MouseEvent) => {
        setMenu(!menu);
    }

    return (
        <header>
            <div className="container">
                <Link to={isLoan ? "/loan" : "/"}>
                    <img className="logo" src={currentLogo} alt={isLoan ? "Yemeksepeti" : "Yemekpay"} />
                </Link>
                {!isLoan && (
                    <>
                        <button className="btn-menu mobile-only" type="button" onClick={toggleMenu}>
                            {menu ?
                                <Image src={imported_asset_index_tsx_0} />
                                :
                                <Image src={imported_asset_index_tsx_1} />
                            }
                        </button>
                        <div className={"menu-container" + (menu ? " active" : "")} onClick={() => setMenu(false)}>
                            <div className="mobile-only mobile-menu-header">
                                <img className="logo" src={currentLogo} alt="" />
                            </div>
                            <div className="menu">
                                <Link className="button s2" to="/about">Hakkımızda</Link>
                                <Link className="button s2" to="/contact">Bize Ulaşın</Link>
                                <Link className="button s2" to="/corporate-governance">Kurumsal Yönetim</Link>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </header>
    )
}

export default Header;
